<template>
  <naj-confirmation
    :show-modal="showModal"
    :max-width="1000"
    :is-persistent="true"
    :title="title"
    :sub-title="subTitle"
    :show-close-btn="true"
    @cancel="$emit('onCancelModal')"
  >
    <template slot="message-content">
      <v-row>
        <v-col>
          <naj-alert :type="type">
            <template slot="content">
              {{ message }}
            </template>
          </naj-alert>
        </v-col>
      </v-row>
    </template>
    <template
      v-if="okActionName"
      slot="actions"
    >
      <naj-button
        color="var(--app-info-color)"
        outlined
        @click="$emit('onOkActionClick')"
      >
        {{ okActionName }}
      </naj-button>
    </template>
  </naj-confirmation>
</template>

<script>

export default {
  name: 'NajAlertModal',
  components: {},
  props: {
    type: {
      type: String,
      default: 'alert', //alert//information//error//success
    },
    showModal: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
    okActionName: {
      type: String,
      default: null,
    },
    subTitle: {
      type: String,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
</style>
